<template>
    <v-card class="time-card text-primary ma-0"
            min-width="230"
            :width="width ? width : 230"
            @click="selectedTask = task; editDateTime = true"
            variant="outlined">
        <template v-if="startTime && duration">
            <v-tooltip location="bottom"
                       text="Заданы все параметры времени">
                <template v-slot:activator="{ props }">
                    <v-card-title v-bind="props" class="d-flex justify-space-between">
                        <span>{{startTime}} - {{endTime}}</span>
                        <span>&nbsp;({{duration}})</span>
                    </v-card-title>
                </template>
            </v-tooltip>
        </template>
        <template v-else-if="startTime">
            <v-tooltip location="bottom"
                       text="Задано время начала">
                <template v-slot:activator="{ props }">
                    <v-card-title v-bind="props">
                        {{startTime}} - ...
                    </v-card-title>
                </template>
            </v-tooltip>
        </template>
        <template v-else-if="duration">
            <v-tooltip location="bottom"
                       text="Задана длительность">
                <template v-slot:activator="{ props }">
                    <v-card-title v-bind="props" class="d-flex justify-end">
                        ({{duration}})
                    </v-card-title>
                </template>
            </v-tooltip>
        </template>
        <template v-else>
            <v-tooltip location="bottom"
                       text="Время не задано">
                <template v-slot:activator="{ props }">
                    <v-card-title v-bind="props" class="d-flex justify-center">
                        <v-icon v-if="alternativeIcon"
                                :icon="alternativeIcon"
                                :title="alternativeText" />
                        <span v-else>{{alternativeText}}</span>
                    </v-card-title>
                </template>
            </v-tooltip>
        </template>
    </v-card>
</template>

<script>
    export default {
        props: {
            startTime: String,
            endTime: String,
            duration: String,

            alternativeText: String,
            alternativeIcon: String,
            width: String
        }
    };
</script>

<style lang="scss">
    .time-card {
    }
</style>